import { environment } from '../environments';

const BASE_URL = environment.baseUrl;

export const API_URL = {
  regeneratetoken: '/v1/authenticate/regeneratetoken/', //pentesting changes
  sign_in: '/v1/authenticate/user/', //pentesting changes
  passkey_sign_in: '/v2/authenticate/user',
  passkey_register: '/v1/passkey/register/',
  passkey_deregister: '/v1/passkey/deregister',
  passkey_list: '/v1/passkey/list/',
  has_passkey_registered: (accountId: string, customerId: string) =>
    `/profile/v1/account/${accountId}/customer/${customerId}/hasPasskeyRegistered`,
  sign_out: (accId: string) =>
    `/v1/authenticate/user/signout?accountId=${accId}`,
  account_details: (accId: string, customerId: string) =>
    `/corebank/v1/account/${accId}/customer/${customerId}/detail`,
  address_details: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/address/options`,
  email_details: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/email/options`,
  phone_details: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/phone/options`,
  update_address_details: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/address`,
  update_email_details: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/email`,
  update_phone_details: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/phone`,
  update_preferredLanguage: (accId: string, customerId: string) =>
    `/profile/v1/card/customer/${accId}/${customerId}/language`,
  statement_preference: (accId: string, customerId: string) =>
    `/profile/v1/popup/statement/paper/${accId}/customer/${customerId}/preferences`,
  reward_balance: (accId: string) =>
    `/rewards/v1/points-details?breakdown_level=TOTALS&components=CURRENT_BALANCE&user_id=${accId}&user_id_type=RANAC`,
  view_card_details: '/viewcard',

  transactions: (
    accId: string,
    customerId: string,
    limit?: number,
    cycleStartDate?: string,
    customerTypeId?: string,
    fromDate?: string,
    toDate?: string,
    merchantCategory?: string,
    offset?: number,
    isRefresh?: boolean
  ) => {
    console.log('offset mapper', offset);
    let url = `/corebank/v1/account/${accId}/customer/${customerId}/transactions`;
    const params = [];

    if (limit !== undefined) {
      params.push(`limit=${limit}`);
    }
    if (offset !== undefined) {
      params.push(`offset=${offset}`);
    }
    if (cycleStartDate) {
      params.push(`cycleStartDate=${cycleStartDate}`);
    }
    if (fromDate && toDate) {
      params.push(`fromDate=${fromDate}&toDate=${toDate}`);
    }
    if (merchantCategory) {
      params.push(`merchantCategory=${merchantCategory}`);
    }
    if (customerTypeId) {
      params.push(`customer=${customerTypeId}`);
    }

    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    return url;
  },
  epp: (accId: string, customerId: string) =>
    `/corebank/v1/account/${accId}/customer/${customerId}/view/epp`,
  get_epp_options: (accId: string, customerId: string, activityId: string) =>
    `/corebank/v1/account/${accId}/customer/${customerId}/installmentplans/qualifiedoptions?activityId=${activityId}`,
  create_epp_plan: (accId: string, customerId: string) =>
    `/corebank/v1/account/${accId}/customer/${customerId}/installmentplan`,
  create_zero_percent_epp: `/corebank/v1/account/epp/zeropercent/posteligibletransactions`,
  account_maindetails: (accId: string) => `/corebank/v1/account/${accId}`,
  // Lock card
  fetch_card_lock: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/lockstatus`,
  update_card_lock: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/lockstatus`,
  validate_passcode: `/v1/authenticate/validatepasscode/`, //pentesting changes
  generate_code_for_device: `/v1/authenticate/generatecodefordevice/`, //pentesting changes
  preferences_user: '/v1/authenticate/preferences/user/', //pentesting changes
  passkey_preferences_user: '/v1/passkey/preferences/',
  passkey_generate_code: '/v1/passkey/generateotp/',
  passkey_validate_passcode: '/v1/passkey/submitotp/',
  statements: (accId: string, customerId: string, nextEndDate: string) =>
    nextEndDate
      ? `/corebank/v1/account/${accId}/customer/${customerId}/estatement/search?End Date=${nextEndDate}`
      : `/corebank/v1/account/${accId}/customer/${customerId}/estatement/search`,
  initiateStatement: (accId: string, customerId: string, statementId: string) =>
    `/corebank/v1/account/${accId}/customer/${customerId}/estatement/${statementId}/initiate-download`,
  jobStatusStatement: (accId: string, customerId: string, jobId: string) =>
    `/corebank/v1/account/${accId}/customer/${customerId}/estatement/status/${jobId}`,
  viewStatement: (accId: string, customerId: string, statementId: string) =>
    `/corebank/v1/account/${accId}/customer/${customerId}/estatement/${statementId}/view`,
  downloadTransactions: (
    accountId: string,
    customerId: string,
    cycleDate: string
  ) =>
    cycleDate
      ? `/corebank/v1/account/${accountId}/customer/${customerId}/activity?cycleStartDate=${cycleDate}`
      : `/corebank/v1/account/${accountId}/customer/${customerId}/activity`,
  contact_details: (accountId: string, customerId: string) =>
    `/corebank/v1/account/${accountId}/customer/${customerId}/contact/detail`,
  display_business_name: (accountId: string) =>
    `/corebank/v1/account/customer/${accountId}/accountinformation?customerType=BUSINESS`,
  // popup tset
  fetch_popup: (accId: string, customerId: string) =>
    `/profile/v1/popup/account/${accId}/customer/${customerId}/ui/popup`,
  update_popup: (accId: string, customerId: string) =>
    `/profile/v1/popup/account/${accId}/customer/${customerId}/ui/popup`,
  change_password: (accId: string, customerId: string) =>
    `/profile/v1/account/${accId}/customer/${customerId}/password`,

  activate_card_pin: (accId: string, customerId: string) =>
    `/profile/v2/card/account/${accId}/customer/${customerId}/activate`,
  change_pin: (accId: string, customerId: string) =>
    `/corebank/v1/account/card/${accId}/customer/${customerId}/setuppin`,
  account_status: (accId: string, customerId: string) =>
    `/corebank/v1/account/${accId}/customer/${customerId}/status`,
  contactPreferences: (
    accountId: string,
    primaryCustomerId: string,
    customerId: string
  ) =>
    `/profile/v1/card/account/${accountId}/customers/${primaryCustomerId}/contactpreferences/${customerId}`,
  fetch_redeem_reward: (
    accId: string,
    cardLastFourDigits: string,
    redemptionType: string
  ) =>
    `/rewards/v1/redeemers/${accId}?cardLastFourDigits=${cardLastFourDigits}&redemption_type=${redemptionType}&user_id_type=RANAC`,
  fetch_redeem_reward_preferences: (
    accId: string,
    redemptionType: string,
    cardLastFourDigits: string
  ) =>
    `/rewards/v1/redeemers/${accId}?cardLastFourDigits=${cardLastFourDigits}/preferences?redemption_type=${redemptionType}&user_id_type=RANAC`,
  update_redeem_reward_preferences: (
    accountId: string,
    cardLastFourDigits: string,
    redemptionType: string
  ) =>
    `/rewards/v1/redeemers/${accountId}/preferences?cardLastFourDigits=${cardLastFourDigits}&redemption_type=${redemptionType}`,
  redeem_reward_search: (cardLastFourDigits: string) =>
    `/rewards/v1/redeemers/search?cardLastFourDigits=${cardLastFourDigits}`,
  fetch_reward_transaction: (
    cardLastFourDigits: string,
    offset: number,
    limit: number,
    isYtd: boolean
  ) =>
    `/rewards/v1/transactions/searches?cardLastFourDigits=${cardLastFourDigits}&offset=${offset}&limit=${limit}&isYtd=${isYtd}`,
  fetch_reward_authorization: (
    accId: string,
    cardLastFourDigits: string,
    fromDate: string,
    toDate: string,
    includeResponse: boolean
  ) =>
    `/rewards/v1/authorizations?user_id=${accId}&cardLastFourDigits=${cardLastFourDigits}&from_date=${fromDate}&to_date=${toDate}&user_id_type=RANAC&include_reprocessed=${includeResponse}`,
  update_reward_authorization: `/rewards/v1/authorizations`,
  update_reward_authorization_reprocess: (
    id: string,
    cardLastFourDigits: string
  ) =>
    `/rewards/v1/authorizations/${id}/reprocess?cardLastFourDigits=${cardLastFourDigits}`,
  redeem_rewards_points: (
    breakdownlevel: string,
    pointsRedeem: string,
    currentBalance: string,
    previousBalance: string,
    pointEarned: string,
    accountId: string,
    cardLastFourDigits: string,
    userIdType: string,
    fromDate: string,
    toDate: string
  ) =>
    `/rewards/v1/points-details?breakdown_level=${breakdownlevel}&components=${pointsRedeem}&components=${currentBalance}&components=${previousBalance}&components=${pointEarned}&user_id=${accountId}&cardLastFourDigits=${cardLastFourDigits}&user_id_type=${userIdType}&from_date=${fromDate}&to_date=${toDate}`,
  redeem_rewards_points_adjustments_details: (
    accountId: string,
    cardLastFourDigits: string,
    userIdType: string,
    fromDate: string,
    toDate: string,
    excludeOtherAccount: boolean,
    isYtd: boolean
  ) =>
    `/rewards/v1/points-adjustments-details?user_id=${accountId}&cardLastFourDigits=${cardLastFourDigits}&user_id_type=${userIdType}&from_date=${fromDate}&to_date=${toDate}&exclude_other_accounts=${excludeOtherAccount}&isYtd=${isYtd}`,
  reward_user_references: `/rewards/v1/users/references/searches`,
  address_update: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/address`,
  email_update: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/email`,
  phone_update: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/phone`,
  language_update: (accId: string, customerId: string) =>
    `/profile/v1/card/customer/${accId}/${customerId}/language`,
  fetch_employee_profile: (customerId: string) =>
    `/profile/v1/rci/fetchemployee/${customerId}`,
  fetch_casehistory: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/casehistory`,
  secure_message: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/securemessage`,
  secure_message_options: (accId: string, customerId: string) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/securemessage/options`,
  secure_message_details: (
    accId: string,
    customerId: string,
    detailId: string
  ) =>
    `/profile/v1/card/account/${accId}/customer/${customerId}/securemessage/detail/${detailId}`,
  authorized_user: (accId: string, customerId: string) =>
    `/corebank/v1/authorization/account/${accId}/${customerId}/authorizeduser`,
  authorized_user_options: (accId: string, customerId: string) =>
    `/corebank/v1/authorization/account/${accId}/${customerId}/authorizeduser/options`,
  fetch_bank_account_detail: (accId: string) =>
    `/profile/v1/rci/bankaccountid/${accId}`,
  fetch_active_alerts: (accountId: string, customerId: string) =>
    `/profile/v1/alert/fetchActiveAlerts/account/${accountId}/customer/${customerId}`,
  fetch_active_alerts_v2: (accountId: string, customerId: string) =>
    `/profile/v2/alert/fetchActiveAlerts/account/${accountId}/customer/${customerId}`,
  fetch_alert_contact_preferences:
    '/profile/v1/alert/platform/notification/customer/preferences/contacts',
  update_alert_preferences:
    '/profile/v1/alert/platform/notification/user/preferences/alerts',
  update_alert_contact_preferences:
    '/profile/v1/alert/platform/notification/customer/preferences/contacts',
  send_sms_verification:
    '/profile/v1/alert/platform/notification/customer/preferences/contacts/phone/verification',
  phone_options: (accountId: string, customerId: string) =>
    `/profile/v1/card/account/${accountId}/customer/${customerId}/phone/options`,
  update_phone: (accountId: string, customerId: string) =>
    `/profile/v1/card/account/${accountId}/customer/${customerId}/phone`,
  email_options: (accountId: string, customerId: string) =>
    `/profile/v1/card/account/${accountId}/customer/${customerId}/email/options`,
  update_email: (accountId: string, customerId: string) =>
    `/profile/v1/card/account/${accountId}/customer/${customerId}/email`,
  request_replacement_card_options: (accId: string, customerId: string) =>
    `/profile/v1/card/${accId}/customer/${customerId}/request/options`,
  request_replacement_card: (accId: string, customerId: string) =>
    `/profile/v1/card/${accId}/customer/${customerId}/request`,
  instantCreditDetails: '/v1/instantcredit/detail/',
  rewards_history_percentage: (accId: string) =>
    `/rewards/v1/reward-screen/transactions/${accId}`,

  // Ban details
  getBanDetails: (ban: string, accId: string) =>
    `/profile/v1/ban/${ban}/${accId}`,
  initiate_link_card: (accId: string, customerId: string) =>
    `/profile/v1/banlink/account/${accId}/customer/${customerId}/initiateLinkCard`,
  validateSelectedAccount: (accId: string, customerId: string) =>
    `/profile/v1/banlink/account/${accId}/customer/${customerId}/validateSelectedAccount`,
  linkSelectedAccount: (accId: string, customerId: string) =>
    `/profile/v1/banlink/account/${accId}/customer/${customerId}/linkAccount`,
  generateOtp: (accId: string) =>
    `/profile/v1/banlink/account/${accId}/generateOtp`,

  submitOtp: (accId: string) =>
    `/profile/v1/banlink/account/${accId}/submitOtp`,
  unlinkAccount: (accId: string, customerId: string) =>
    `/profile/v1/banlink/account/${accId}/customer/${customerId}/unlinkAccount`,
  request_view_rewards: (ban: string, accId: string) =>
    `/profile/v1/rci/api/v1/viewrlhrewards/${ban}/${accId}`,
  fetchRCIAccountStatus: (accId: string) =>
    `/profile/v1/rci/linkstatus/bankaccountid/${accId}`,
  fetchRCIAccount: (accId: string) => `/profile/v1/rci/bankaccountid/${accId}`,
  fetchRewarduser: (user_id: string) => `/rewards/v1/redeemers/${user_id}`,
  //gettargetedoffer
  fetch_targeted_offer: (accountId: string, customerId: string) =>
    `/profile/v1/card/account/${accountId}/customer/${customerId}/offers`,
  fetch_offerPreferences: (
    accountId: string,
    customerId: string,
    offerPreference: string,
    endDate: string
  ) =>
    `/profile/v1/card/account/${accountId}/customer/${customerId}/offerspreference?OfferPreference=${offerPreference}&endDate=${endDate}`,
  fetch_targetedOfferPrefSubmit: (accountId: string, customerId: string) =>
    `/profile/v1/card/targetoffer/updatetargetoffer/account/${accountId}/customer/${customerId}`,
  // View Offers API
  fetch_view_offers: (accountId: string, customerId: string) =>
    `/profile/v1/card/account/${accountId}/customer/${customerId}/offers`,
  //Loyalty Hub landing page
  fetchRlhStatus: (accountId: string, customerId: string) =>
    `/rewards/loyalty/v1/rlhStatus/account/${accountId}/customer/${customerId}`,
  fetchLhrewardStatus: (accountId: string, customerId: string) =>
    `/rewards/loyalty/v1/rewardStatus/account/${accountId}/customer/${customerId}`,
  lhSsoLogin: (accountId: string, customerId: string, productName: string) =>
    `/rewards/loyalty/v1/saml/ssologin/account/${accountId}/customer/${customerId}`,
  entertainmentCredit_Submit: (accountId: string) =>
    `/profile/v1/entertain/account/${accountId}/submit`,
  getAccountProtectionInsuranceDetail: (
    accountId: string,
    customerId: string
  ) =>
    `/addons/v1/account/${accountId}/customer/${customerId}/rap/detail`,
  enrollAccountProtectionService: (accountId: string, customerId: string) =>
    `/addons/v1/account/${accountId}/customer/${customerId}/rap`,
};
